const mutations = {
	['UPDATE_USER_INFO'] (state, userInfo) {
		state.isLogin = userInfo.isLogin || false;
		state.userName = userInfo.userName || '';
		state.photo = userInfo.photo || '';
		state.userId = userInfo.userId || '';
		state.userToken = userInfo.userToken || '';
		state.appLogoURL = userInfo.appLogoURL || '';
	},

	['UPDATE_USER_TOKEN'] (state, payload) {
		state.userToken = payload.userToken;
	},
};

export default mutations;